import { Component, h, Host, Prop } from '@stencil/core';
import { icoTabItem, actionItems } from '../../../interfaces/interface.tabGroup';

@Component({
  tag: 'ico-banner-tab-group',
  styleUrl: 'ico-banner-tab-group.css',
  shadow: true,
})
export class IcoBannerTabGroup {
  @Prop() tabs: icoTabItem[] = [];
  @Prop() selectedKey: string = '';
  @Prop() actions: actionItems;
  @Prop() showDesktop: boolean;

  render() {
    return (
      <Host>
        <div class="m-auto font-ico-body">
          <div class="flex items-center gap-2 sm:gap-8 -mt-1">
            {this.tabs.map((item) => {
              const isSelected = item.key === this.selectedKey;
              const tabTextClasses = {
                'text-base w-fit border-solid border-x-0 border-t-0 cursor-pointer sm:mr-1 ml-px': true,
                'font-extrabold border-b-4 border-b-color': isSelected,
                'border-b-0': !isSelected,
              };

              return (
                <div class="text-left sm:h-auto" data-testid={`bi-tab-${item.label.replace(' ', '')}`} onClick={() => this.actions.select(item.key)}>
                  <div class={tabTextClasses}>{item.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </Host>
    );
  }
}